function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import merge from "lodash/merge";
import * as ActionTypes from "../../actions";

// Updates an entity cache in response to any action with response.entities.
var brokerFollowerEntities = function brokerFollowerEntities() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    byUserIdAndBrokerId: {}
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case ActionTypes.GET_BROKERVIEWBYBROKERIDANDAUTHUSERID_SUCCESS:
      var byUserIdAndBrokerId = action.response.brokerFollowerByUserIdAndBrokerId;
      return merge({}, state, {
        byUserIdAndBrokerId: byUserIdAndBrokerId
      });
    case ActionTypes.POST_BROKERFOLLOWER_SUCCESS:
      var byUserIdAndBrokerId = _objectSpread({}, state.byUserIdAndBrokerId);
      var embedded = action.response._embedded;
      var key = [action.brokerFollower.userId, action.brokerFollower.brokerId].join("-");
      byUserIdAndBrokerId[key] = embedded;
      return Object.assign({}, state, {
        byUserIdAndBrokerId: byUserIdAndBrokerId
      });
    case ActionTypes.DELETE_BROKERFOLLOWER_SUCCESS:
      var byUserIdAndBrokerId = _objectSpread({}, state.byUserIdAndBrokerId);
      Object.keys(state.byUserIdAndBrokerId).map(function (key) {
        var brokerFollower = state.byUserIdAndBrokerId[key];
        if (brokerFollower && brokerFollower.id === action.brokerFollower.id) byUserIdAndBrokerId[key] = undefined;
      });
      return Object.assign({}, state, {
        byUserIdAndBrokerId: byUserIdAndBrokerId
      });
    default:
      return state;
  }
};
export default brokerFollowerEntities;